import { LAYOUT_SETUP_CONSTANTS } from 'actionTypes/layoutSetup';
import createAction from 'helpers/createAction';

export const changeTradeLayoutVisible = createAction(
  LAYOUT_SETUP_CONSTANTS.UPDATE_LAYOUT_SETUP
);

export const changeTradeScreenLayout = createAction(
  LAYOUT_SETUP_CONSTANTS.CHANGED_LAYOUT
);

export const changeShowRecentTradePanel = createAction(
  LAYOUT_SETUP_CONSTANTS.CHANGE_SHOW_RECENT_TRADE_PANEL
);

export const resetTradeScreenLayout = createAction(LAYOUT_SETUP_CONSTANTS.RESET_LAYOUT);

export const resetTradeScreenLayoutCallback = createAction(
  LAYOUT_SETUP_CONSTANTS.RESET_LAYOUT_CALLBACK
);

export const updateGridLayout = createAction(LAYOUT_SETUP_CONSTANTS.UPDATE_GRID_LAYOUT);

export const resetGridLayout = createAction(LAYOUT_SETUP_CONSTANTS.RESET_GRID_LAYOUT);

export const resizedHoldingPanel = createAction(
  LAYOUT_SETUP_CONSTANTS.RESIZED_HOLDING_PANEL
);
